<template>
  <div>
    <OneConfirm
      v-for="(service, index) in selectedServices"
      :service="service"
      :idx="index"
      :key="index"
      :cid="cid"
      :sid="sid"
    ></OneConfirm>
  </div>
</template>
<script>
import OneConfirm from "@/components/OneConfirm/OneConfirm.vue";
import { mapState } from "vuex";
export default {
  name: "Confirms",
  props: ["sid","cid"],
  components: {
    OneConfirm
  },
  computed: {
    ...mapState("client", ["selectedServices"])
  }
};
</script>
